import { CommonModule } from '@angular/common';
import { afterNextRender, Component, inject, signal } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { injectNavigationEnd } from 'ngxtension/navigation-end';

type Segment = 'summary' | 'month' | 'detail';

/**
 * 수납 관리 > 수납 내역
 */
@Component({
  selector: 'app-receipt-list',
  templateUrl: './receipt-list.layout.html',
  styleUrls: ['./receipt-list.layout.scss'],
  imports: [CommonModule, RouterOutlet, RouterLink],
})
export class ReceiptListLayout {
  readonly router = inject(Router);
  readonly navigationEnd$ = injectNavigationEnd();

  segment = signal<Segment>('summary');

  constructor() {
    afterNextRender(() => {
      this.setSegment();
      this.navigationEnd$.subscribe({
        next: () => this.setSegment(),
      });
    });
  }

  setSegment() {
    const url = this.router.url;

    if (url.includes('summary')) {
      this.segment.set('summary');
    } else if (url.includes('month')) {
      this.segment.set('month');
    } else if (url.includes('detail')) {
      this.segment.set('detail');
    }
  }
}
